// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(>section[data-testid=popover-menu]){top:auto !important;margin-top:15px !important}`, "",{"version":3,"sources":["webpack://./overrides/app/components/list-menu/list-menu.scss"],"names":[],"mappings":"AAAA,4CACI,mBAAA,CACA,0BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
